/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';
import Referlottie from "../Lottie/refernearn.json";
import Lottie from 'lottie-react';
import { MdOutlineContentCopy } from 'react-icons/md';
import Icon from "../../assets/Image/lovef.png";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { LuChevronRight, LuCheck } from 'react-icons/lu';
import { IoChevronBackOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const ReferAndEarn = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl } = useContext(MyContext);
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [currency, setCurrency] = useState();
    const [loading, setLoading] = useState(true);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        const site_currency = secureLocalStorage.getItem("currency");
        const curr = site_currency ? site_currency : "$";
        setCurrency(curr);

        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/referral_data`, { id: Userid })
                .then((res) => {
                    // console.log(res);
                    setData(res.data.fererral_data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("referdata.php", error);
                });
        }
    }, []);

    const handleCopyClick = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            showToast({ title: t("Text copied to clipboard !!"), id: "success" });
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch((err) => {
            console.error('Failed to copy text: ', err);
        });
    };

    useEffect(() => {
        document.body.style.overflow = loading ? "hidden" : "auto";
    }, [loading]);

    const steps = [
        {
            label: t("Share the Referral Link with Your Friends"),
            sub: t("Send your unique code to anyone"),
        },
        {
            label: `${t("Friend Gets")} ${currency || "$"}${data.signup_credit} ${t("On First Complete Transaction")}`,
            sub: t("They get rewarded instantly"),
        },
        {
            label: `${t("You Get")} ${currency || "$"}${data.refer_credit} ${t("On Your Wallet")}`,
            sub: t("Wallet credit added automatically"),
        },
    ];

    return (
        <div className="refer-earn-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
            {loading ? (
                <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" index={0} />
            ) : (
                <div className="flex flex-col">
                    {/* Header Navigation */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
                        <button
                            onClick={() => window.history.back()}
                            className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
                        >
                            <IoChevronBackOutline className="w-4 h-4" />
                            <span className="font-medium text-sm">{t("Go Back")}</span>
                        </button>
                        <div className="flex items-center gap-2 text-sm text-slate-500">
                            <span className="hover:text-indigo-600 font-medium transition-colors cursor-pointer" onClick={() => navigate("/dashbord")}>{t("Dashboard")}</span>
                            <LuChevronRight className="w-3.5 h-3.5" />
                            <span className="font-semibold text-slate-800">{t("Refer & Earn")}</span>
                        </div>
                    </div>

                    {/* Main Card */}
                    <div className="max-w-xl mx-auto w-full flex flex-col gap-6">

                        {/* Hero Banner */}
                        <div className="bg-gradient-to-br from-indigo-600 via-indigo-500 to-violet-600 rounded-3xl p-8 flex flex-col items-center text-center shadow-lg shadow-indigo-200 relative overflow-hidden">
                            <div className="absolute -top-10 -right-10 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none" />
                            <div className="absolute -bottom-8 -left-8 w-36 h-36 bg-white/10 rounded-full blur-2xl pointer-events-none" />

                            <Lottie
                                animationData={Referlottie}
                                loop={true}
                                className="w-40 h-40 z-10"
                            />

                            <h2 className="text-white font-black text-2xl sm:text-3xl leading-tight mt-2 z-10">
                                {t("Earn")} <span className="text-yellow-300">{currency || "$"}{data.signup_credit}</span>
                            </h2>
                            <p className="text-white/70 text-sm font-medium mt-1 z-10">{t("For Each Friend You Refer")}</p>
                        </div>

                        {/* How It Works */}
                        <div className="bg-white rounded-3xl border border-slate-150 shadow-sm p-6 flex flex-col gap-4">
                            <h3 className="font-bold text-slate-800 text-lg">{t("How It Works")}</h3>
                            <div className="flex flex-col gap-4">
                                {steps.map((step, i) => (
                                    <div key={i} className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-2xl bg-indigo-50 border border-indigo-100 flex items-center justify-center shrink-0 shadow-sm">
                                            <img src={Icon} alt="step" className="w-5 h-5 object-contain" />
                                        </div>
                                        <div className="flex-1 min-w-0 pt-0.5">
                                            <p className="font-bold text-slate-800 text-sm leading-snug">{step.label}</p>
                                            <p className="text-slate-400 text-xs font-medium mt-0.5">{step.sub}</p>
                                        </div>
                                        <div className="w-6 h-6 rounded-full bg-indigo-600 flex items-center justify-center shrink-0 mt-0.5">
                                            <span className="text-white text-[10px] font-black">{i + 1}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Referral Code Card */}
                        <div className="bg-white rounded-3xl border border-slate-150 shadow-sm p-6 flex flex-col gap-4">
                            <div>
                                <h3 className="font-bold text-slate-800 text-lg">{t("Your Referral Code")}</h3>
                                <p className="text-slate-400 text-xs font-medium mt-0.5">{t("Share this code with your friends")}</p>
                            </div>

                            <button
                                onClick={() => handleCopyClick(data.referral_code)}
                                className={`w-full flex items-center justify-between gap-4 px-5 py-4 rounded-2xl border-2 transition-all duration-200 active:scale-95 ${
                                    copied
                                        ? "border-emerald-500 bg-emerald-50"
                                        : "border-indigo-200 bg-indigo-50 hover:border-indigo-400 hover:bg-indigo-100"
                                }`}
                            >
                                <span className={`font-black text-xl tracking-widest ${copied ? "text-emerald-700" : "text-indigo-700"}`}>
                                    {data.referral_code}
                                </span>
                                <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 transition-all duration-200 ${copied ? "bg-emerald-500" : "bg-indigo-600"}`}>
                                    {copied
                                        ? <LuCheck className="w-5 h-5 text-white" />
                                        : <MdOutlineContentCopy className="text-white text-lg" />
                                    }
                                </div>
                            </button>

                            <p className="text-center text-slate-400 text-xs font-semibold">
                                {copied ? t("✓ Copied to clipboard!") : t("Tap to copy your referral code")}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReferAndEarn;
/* jshint ignore:end */